import React from 'react'

const GlobalsContext = React.createContext({
  school: null,
  loggedUser: null,
  // other constants fetched from essentials/getglobals
})

export default GlobalsContext
